export default {
  install(Vue) {
    Vue.prototype.$Add = function(arg1, arg2) {
      arg1 = arg1.toString(), arg2 = arg2.toString()
      var arg1Arr = arg1.split('.'), arg2Arr = arg2.split('.'), d1 = arg1Arr.length == 2 ? arg1Arr[1] : '', d2 = arg2Arr.length == 2 ? arg2Arr[1] : ''
      var maxLen = Math.max(d1.length, d2.length)
      var m = Math.pow(10, maxLen)
      var result = Number(((arg1 * m + arg2 * m) / m).toFixed(maxLen))
      var d = arguments[2]
      return typeof d === 'number' ? Number((result).toFixed(d)) : result
    }
    Vue.prototype.$Sub = function(arg1, arg2) {
      return Vue.prototype.$Add(arg1, -Number(arg2), arguments[2])
    }
    Vue.prototype.$Mul = function(arg1, arg2) {
      var r1 = arg1.toString(), r2 = arg2.toString(), m, resultVal, d = arguments[2]
      m = (r1.split('.')[1] ? r1.split('.')[1].length : 0) + (r2.split('.')[1] ? r2.split('.')[1].length : 0)
      resultVal = Number(r1.replace('.', '')) * Number(r2.replace('.', '')) / Math.pow(10, m)
      return typeof d !== 'number' ? Number(resultVal) : Number(resultVal.toFixed(parseInt(d)))
    }
    Vue.prototype.$Div = function(arg1, arg2) {
      var r1 = arg1.toString(), r2 = arg2.toString(), m, resultVal, d = arguments[2]
      m = (r2.split('.')[1] ? r2.split('.')[1].length : 0) - (r1.split('.')[1] ? r1.split('.')[1].length : 0)
      resultVal = Number(r1.replace('.', '')) / Number(r2.replace('.', '')) * Math.pow(10, m)
      return typeof d !== 'number' ? Number(resultVal) : Number(resultVal.toFixed(parseInt(d)))
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/math.js